import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export class SafeWindow {
  private static _instance: Window | null;

  static get(): Window | null {
    if (this._instance !== undefined) return this._instance;

    const platformId = inject(PLATFORM_ID);
    this._instance = isPlatformBrowser(platformId) ? window : null;
    return this._instance!;
  }
}
